/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import PropTypes from 'prop-types';

import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import savedStyles from '../SavedLocation/SavedLocations.module.css';
import styles from './FeaturedLocation.module.css';

const FeaturedLocation = ({ label, value, icon, onClick, dataPart }) => {
  const isBrandRefreshCurrentLocation =
    dataPart === 'current-location' && isBrandRefreshEnabled();
  const isBrandRefreshFavoriteBakery =
    dataPart === 'favorite-bakery' && isBrandRefreshEnabled();

  if (isBrandRefreshFavoriteBakery) {
    return (
      <div
        role="button"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClick();
          }
        }}
        onClick={onClick}
        data-part={dataPart}
        className={[savedStyles.savedAddressItem, savedStyles.clickable].join(' ')}
      >
        <div className={savedStyles.icon}>
          <img alt="" src={icon} />
        </div>
        <div className={savedStyles.addressContent}>
          {label ? (
            <div className={savedStyles.labelBlock}>
              <span>{label}</span>
            </div>
          ) : null}
          {value ? <div className={savedStyles.addressText}>{value}</div> : null}
        </div>
      </div>
    );
  }

  const labelElement = (
    <p
      className={isBrandRefreshCurrentLocation ? undefined : 'text-[#745881] ml-3'}
      data-part={isBrandRefreshCurrentLocation ? 'current-location-label' : undefined}
    >
      {label}
    </p>
  );

  const valueElement = isBrandRefreshCurrentLocation ? (
    <p data-part="current-location-value">{value}</p>
  ) : (
    <h3 className="text-[#461D58] ml-3">{value}</h3>
  );

  return (
    <div
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
      onClick={onClick}
      data-part={dataPart}
      className={
        isBrandRefreshCurrentLocation
          ? undefined
          : `${styles.featuredLocation} font-montserratMedium bg-[var(--light-elevation-background-alt, #F6F3F7)] flex w-full`
      }
    >
      {isBrandRefreshCurrentLocation ? (
        <>
          <div data-part="current-location-icon">
            <img alt="" src={icon} />
          </div>
          <div data-part="current-location-content">
            {labelElement}
            {valueElement}
          </div>
        </>
      ) : (
        [
          <img key="icon" alt="" src={icon} />,
          <div key="text" className="ml-3">
            {labelElement}
            {valueElement}
          </div>,
        ]
      )}
    </div>
  );
};

FeaturedLocation.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  dataPart: PropTypes.string,
};

FeaturedLocation.defaultProps = {
  dataPart: undefined,
};

export default FeaturedLocation;
